export * from "./PatientDetails.async";
